import { jsx as _jsx } from "react/jsx-runtime";
import TablePagination from "@mui/material/TablePagination";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageActions from "./components/pageActions";
import { nerdPaginationAuxContent } from "./typings";
const NerdPagination = ({ page, rowsPerPage, rowPageOptions, selectPages, disabledNext, handleChangePage, handleChangeRowsPerPage, }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("sm"));
    const StyledTablePagination = styled(TablePagination)({
        ".MuiToolbar-root": {
            ...(matches && { flexWrap: "wrap", justifyContent: "center" }),
            ".MuiTablePagination-spacer": {
                display: "none",
            },
            ".paginationContainer": {
                ...(matches ? { justifyContent: "center" } : { flexWrap: "nowrap" }),
            },
        },
        ".MuiPagination-roo": {
            display: "inline",
            ".MuiPagination-ul": {
                display: "inline",
                li: {
                    display: "inline",
                },
            },
        },
    });
    return (_jsx(StyledTablePagination, { component: "div", count: -1, page: page, onPageChange: handleChangePage, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowPageOptions, onRowsPerPageChange: handleChangeRowsPerPage, ActionsComponent: (props) => (_jsx(PageActions, { selectPages: selectPages, disabledNext: disabledNext, ...props })), labelDisplayedRows: () => {
            return "";
        }, labelRowsPerPage: nerdPaginationAuxContent.Rows, getItemAriaLabel: (type) => `Go to ${type} page`, backIconButtonProps: {
            "aria-label": "Previous Page",
        }, nextIconButtonProps: {
            "aria-label": "Next Page",
        }, className: `nerdUI--pagination ${matches ? "nerdUI--pagination-sm" : ""}` }));
};
export default NerdPagination;
